<template>
  <SectionShell :icon="meta.icon || 'hashtag'" :label="meta.label || fieldKey" :count="fieldSlot.values.size">
    <div :style="{ fontSize: '10px', color: 'var(--p-surface-400)', padding: '0 2px 6px', fontFamily: mono }">exact id match</div>
    <div v-if="selected.length > 0" :style="{ display: 'flex', flexWrap: 'wrap', gap: '5px', padding: '0 2px 7px' }">
      <span
        v-for="v in selected"
        :key="v"
        :style="{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '5px',
          maxWidth: '100%',
          background: 'var(--p-highlight-background, color-mix(in srgb, var(--p-primary-500) 14%, transparent))',
          borderRadius: '999px',
          padding: '2px 4px 2px 9px',
          fontSize: '11.5px',
          fontFamily: mono,
          color: 'var(--p-text-color)',
        }"
      >
        <span :style="{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }">{{ v }}</span>
        <button
          :style="{ background: 'transparent', border: 0, padding: '2px', cursor: 'pointer', color: 'var(--p-surface-400)', display: 'flex' }"
          @click="search.toggleValue(fieldKey, v)"
        >
          <i class="pi pi-times" :style="{ fontSize: '9px' }" />
        </button>
      </span>
    </div>
    <div :style="{ display: 'flex', gap: '6px' }">
      <input
        v-model="text"
        spellcheck="false"
        :placeholder="`Exact ${meta.label || fieldKey}…`"
        :style="rangeInput"
        @keydown.enter="add"
      >
      <button
        :style="{ flexShrink: 0, padding: '0 12px', borderRadius: '7px', border: '1px solid var(--p-content-border-color)', background: 'transparent', color: 'var(--p-text-muted-color)', fontSize: '12px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }"
        @click="add"
      >Add</button>
    </div>
  </SectionShell>
</template>

<script setup>
// Exact-id section (objectId): add/remove individual values as chips. Ported
// from fql-search.jsx ExactSection.
import { ref, computed } from 'vue'
import { mono, rangeInput } from './bits.js'
import SectionShell from './SectionShell.vue'

// SearchSidebar hands every section the same prop bag. This one reads no decl,
// and `inheritAttrs: false` keeps the undeclared binding off SectionShell's
// root element rather than letting it render there as an attribute.
defineOptions({ name: 'ExactSection', inheritAttrs: false })

const props = defineProps({
  fieldKey: { type: String, required: true },
  fieldSlot: { type: Object, required: true },
  meta: { type: Object, default: () => ({}) },
  search: { type: Object, required: true },
})

const text = ref('')
const selected = computed(() => [...props.fieldSlot.values])
function add() {
  const v = text.value.trim()
  if (v) {
    props.search.toggleValue(props.fieldKey, v)
    text.value = ''
  }
}
</script>
